<div class="flex flex-row gap-2.5 justify-center items-center w-full py-2.5">
  <div class="login-line" fxFlex></div>
  <div>
    <span class="grey-ico mat-subheading-1">{{"connectWith"|translate}}</span>
  </div>
  <div class="login-line" fxFlex></div>
</div>

<div class="flex flex-row items-center justify-center gap-4">

    <!-- Facebook -->
    <button
      [ngClass]="cssService.defaultSocialButton"
      class="bg-blue-600"
      (click)="signInCredential('facebook')"
      angulartics2On="click"
      angularticsAction="openFacebookLogin"
      angularticsCategory="login">
      <i class="fab fa-facebook"></i>
    </button>

    <!-- Twitter -->
    <button
      [ngClass]="cssService.defaultSocialButton"
      class="bg-sky-500"
      (click)="signInCredential('twitter')"
      angulartics2On="click"
      angularticsAction="openTwitterLogin"
      angularticsCategory="login">
      <i class="fab fa-twitter"></i>
    </button>

    <!-- Google -->
    <button
      [ngClass]="cssService.defaultSocialButton"
      class="bg-red-500"
      (click)="signInCredential('google')"
      angulartics2On="click"
      angularticsAction="openGoogleLogin"
      angularticsCategory="login">
      <i class="fab fa-google"></i>
    </button>

</div>
